import * as React from "react";

import {ModalProps} from "../../../../../shared/ts/decorators/modalix";
import {ISurpriseFormValues} from "../../../advertisments/reducers/surprise";
import {SurpriseCreationAdPreview} from "./SurpriseAdCreationPreview";

interface IProps extends ModalProps {
    modalTitle?: JSX.Element | string;
    imageAdCreationFormData: ISurpriseFormValues;
}

export const SurpriseAdCreationAdModal = (props: IProps) => {
    return (
        <div className="modal-dialog modal-primary modal-native-ad" >
            <div className="bd-0 modal-content" tabIndex={0}>
                <div className="modal-header-box p-md fs16 modal-header text-center">
                    <button className="btn-close close" type="button" onClick={() => props.onReject()}>&times;</button>
                    <h4 className="modal-title">{props.modalTitle || "Podgląd reklam"}</h4>
                </div>
                <SurpriseCreationAdPreview surpriseAdCreationData={props.imageAdCreationFormData} />
            </div>
        </div>
    );
};
